
import { defineComponent, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import ModalBase from '@/components/genenral/ModalBase.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'MagazineModal',

  components: {
    ModalBase,
    Button
  },

  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const closeModal = () => {
      store.commit('unFixBody')
      store.dispatch('closeLimitedModal')
      router.push('/')
    }
    const query = computed(() => {
      return store.state.limitedModalLoginQuery
        ? store.state.limitedModalLoginQuery
        : route.path
    })

    const goTo = (path: string) => {
      router.push(path)
      store.dispatch('closeLimitedModal')
    }

    return {
      closeModal,
      goTo,
      query
    }
  }
})
